import { cn } from '@/lib/utils'

export function DotItMark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'relative grid size-9 shrink-0 place-items-center rounded-xl bg-zinc-950 shadow-sm ring-1 ring-white/10 dark:bg-white',
        className
      )}
      aria-hidden='true'
    >
      <span className='size-3 rounded-full bg-red-500 shadow-[0_0_18px_rgba(239,68,68,.65)]' />
    </span>
  )
}

export function DotItBrand({
  compact = false,
  className,
}: {
  compact?: boolean
  className?: string
}) {
  return (
    <span className={cn('inline-flex items-center gap-3', className)}>
      <DotItMark />
      {!compact && (
        <span className='leading-none'>
          <span className='block text-[15px] font-black tracking-[0.16em]'>
            DOT IT
          </span>
          <span className='mt-1 block text-[10px] font-semibold tracking-[0.18em] text-muted-foreground'>
            SIGNAGE
          </span>
        </span>
      )}
    </span>
  )
}
